import { render, staticRenderFns } from "./ArquitecsoftForm.vue?vue&type=template&id=83530372"
import script from "./ArquitecsoftForm.vue?vue&type=script&lang=js"
export * from "./ArquitecsoftForm.vue?vue&type=script&lang=js"
import style0 from "./ArquitecsoftForm.vue?vue&type=style&index=0&id=83530372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports